import ProfileItemForm from "./ProfileItemForm";
import React from "react";
import ProfileAwardRow from "../../profiles/components/ProfileAwardRow";
import { FormInputComponent } from "../../../components/form/Form";
import { TalentAppCard } from "./TalentAppCard";
import { Input } from "antd";

export default class AwardForm extends ProfileItemForm {

    static ItemType = 'Award'

    static FormClass = 'talent-role-form add-talent-form add-award-form '
    static shouldUseTalentAppCard = true;
    static ShowProfilePreview = true;

    static TypeConfig = {
        icon: 'fas fa-trophy',
        color: TB.config('color.warning')
    }
    /**
     * The fields mapping for the form
     */
    // formFields = () => {

    //     // 'awards.*.year'           => 'required|integer|max:'.now()->year.'|min:1950',
    //     // 'awards.*.name'           => 'required|string|max:255',
    //     // 'awards.*.url'            => 'nullable|string|url|max:255',
    //     // 'awards.*.image_path'     => 'nullable|string|max:255' OR 'nullable|image',
    //     // 'awards.*.description'    => 'nullable|string|max:255',

    //     return [
    //         {
    //             style: styles.fieldSection,
    //             fields: {
    //                 name: {
    //                     type: 'text',
    //                     label: TB.trans('talent.award_form.award_name_label'),
    //                     maxLength: 255,
    //                     required: true,
    //                     placeholder: TB.trans('talent.award_form.award_name_placeholder'),
    //                     style: styles.field,
    //                     columns: 10
    //                 }
    //             }
    //         },
    //         {
    //             style: styles.fieldSection,
    //             fields: {
    //                 year: {
    //                     label: TB.trans('talent.award_form.year_label'),
    //                     placeholder: TB.trans('talent.award_form.year_placeholder'),
    //                     type: 'select',
    //                     required: true,
    //                     options: this.yearOptions(),
    //                     style: styles.field,
    //                     columns: 10
    //                 },
    //             }
    //         },
    //         {
    //             style: styles.fieldSection,

    //             fields: {
    //                 url: {
    //                     label: TB.trans('talent.award_form.award_url_label'),
    //                     placeholder: TB.trans('talent.award_form.award_url_placeholder'),
    //                     type: 'url',
    //                     maxLength: 255,
    //                     required: false,
    //                     style: styles.field,
    //                     columns: 5
    //                 },
    //             }
    //         },
    //         {
    //             style: styles.fieldSection,
    //             fields: {
    //                 image_path: {
    //                     label: TB.trans('talent.award_form.award_logo_label'),
    //                     type: 'pixie',
    //                     maxWidth: 300,
    //                     // height: 150,
    //                     ratio: '1:1',
    //                     circular: false,
    //                     required: false,
    //                     style: styles.field,
    //                     columns: 8
    //                 },
    //             }
    //         },
    //         {
    //             style: styles.fieldSection,
    //             fields: {
    //                 description: {
    //                     label: TB.trans('talent.award_form.summary_paragraph_label'),
    //                     placeholder: TB.trans('talent.award_form.summary_paragraph_placeholder'),
    //                     type: 'textarea',
    //                     required: false,
    //                     style: styles.field,
    //                     maxLength: 10000,
    //                     columns: 10,
    //                     rows: 10
    //                 },
    //             }
    //         },
    //     ]
    // };

    renderTitle() {
        return null;
    }

    renderFormFields() {
        const { isEditing } = this.props;

        if (isEditing) {
            return (
                <TalentAppCard.Section>
                    {this.renderFormData()}
                </TalentAppCard.Section>
            )
        }

        return (
            <TalentAppCard.Section>
                {this.renderFormattedData()}
            </TalentAppCard.Section>
        )
    }

    renderFormData = () => {
        const { disabled, isEditing } = this.props;
        const isDisabled = disabled || !isEditing;
        const yearOptions = this.yearOptions();

        return (
            <div>
                <div className="flex flex-col sm:flex-row gap-4">
                    <div className="field [&_.col-form-label]:mb-0 [&_.col-form-label]:pb-0">
                        <FormInputComponent
                            type="antd-input"
                            fieldName="name"
                            label={TB.trans('talent.award_form.award_name_label')}
                            maxLength={255}
                            required
                            value={this.state.model.name}
                        >
                            <Input
                                placeholder={TB.trans('talent.award_form.award_name_placeholder')}
                                disabled={isDisabled}
                                className="input-default"
                            />
                        </FormInputComponent>
                    </div>
                    <div className="flex flex-row gap-2 form-group field select-field">
                        <div className="w-full max-w-[180px]">
                            <FormInputComponent
                                fieldName="year"
                                label={TB.trans('talent.award_form.year_label')}
                                type="select"
                                required
                                options={yearOptions}
                                value={this.state.model.year}
                            />
                        </div>
                    </div>
                </div>

                <div className="field [&_.invalid-feedback]:relative">

                    <FormInputComponent
                        type="antd-input"
                        fieldName="url"
                        label={TB.trans('talent.award_form.award_url_label')}
                        maxLength={255}
                        required={false}
                        value={this.state.model.url}
                        validation={{
                            rules: {
                                matchRegexp: /^(http|https):\/\//,
                                isUrl: true,
                            },
                            errors: {
                                matchRegexp: 'Must start with http(s)://',
                                isUrl: TB.trans('validation.active_url', {
                                    'attribute': 'url',
                                }),
                            }
                        }}
                    >
                        <Input
                            placeholder={TB.trans('talent.award_form.award_url_placeholder')}
                            disabled={isDisabled}
                            className="input-default"
                        />
                    </FormInputComponent>
                </div>
                <div className="field [&_.invalid-feedback]:relative">
                    <FormInputComponent
                        fieldName="image_path"
                        label={TB.trans('talent.award_form.award_logo_label')}
                        type="pixie"
                        maxWidth={300}
                        ratio="1:1"
                        circular={false}
                        required={false}
                        value={this.state.model.image_path}
                    />
                </div>
                <div className="field">

                    <FormInputComponent
                        fieldName="description"
                        label={TB.trans('talent.award_form.summary_paragraph_label')}
                        type="antd-input"
                        required={false}
                        maxLength={10000}
                        value={this.state.model.description}
                    >
                        <Input.TextArea
                            placeholder={TB.trans('talent.award_form.summary_paragraph_placeholder')}
                            disabled={isDisabled}
                            className="input-default"
                            rows={6}
                            maxLength={10000}
                        />
                    </FormInputComponent>
                </div>
            </div>
        )
    }

    renderFormattedData() {
        const { name, year, url, image_path, description } = this.state.model;

        return (
            <div className="flex flex-col sm:flex-row items-start gap-4">
                {image_path && (
                    <div className="shrink-0">
                        <img
                            src={image_path}
                            alt={`${name} logo`}
                            className="h-[48px] w-[48px] rounded object-contain"
                        />
                    </div>
                )}
                <div className="flex-1 min-w-0">
                    <p className="text-sm font-semibold m-0 truncate">{name || '—'}</p>
                    {year && (
                        <p className="text-xs text-gray-500 mt-1 m-0">{year}</p>
                    )}
                    {url && (
                        <a href={url} target="_blank" rel="noopener noreferrer" className="text-xs text-primary hover:underline truncate block mt-1">
                            {url}
                        </a>
                    )}
                    {description && (
                        <p className="text-xs text-gray-600 mt-2 m-0 line-clamp-2">{description}</p>
                    )}
                </div>
            </div>
        )
    }

    renderFormFooterInfo() {
        return <div />
    }

    renderEditFormButton() {
        return (
            <button
                className="btn btn-primary px-6"
                disabled={this.props.disabled}
                type="button" onClick={() => this.props.onEditing(true)}
            >
                Edit Award
            </button>
        );
    }

    renderProfilePreview() {
        return (
            <TalentAppCard.Section>
                <ProfileAwardRow award={this.getModelFromProps()} />
            </TalentAppCard.Section>
        )
    }
}

const styles = {
    fieldSection: {
        flexDirection: 'row'
    },
    field: {
        padding: '0 15px',
    },
};